import { CLEAR_REFILL_STORE } from '../actions/authActions';
import { currentUserLogout } from '../actions/currentUserActions';
import { persistor } from '../../store';

/**
 * Clear the Redux store and prepare it to be refilled
 *
 * This dispatches the currentUserLogout action which clears out the
 * local storage content. Then it pauses the local storage persistor from
 * saving data to it, flushes any data that's being sent to it, then
 * destroys the persistor. Once the persistor is destroyed, persisting
 * is resumed and a new local storage persist is created.
 */
export const clearRefillStore = (store) => (next) => (action) => {
  next(action);
  if (action.type === CLEAR_REFILL_STORE) {
    store.dispatch(currentUserLogout());
    persistor.pause();
    persistor
      .flush()
      .then(() => {
        return persistor.purge();
      })
      .then(() => {
        persistor.persist();
      });
  }
};
export const clearStoreMdl = [clearRefillStore];
